<template>
  <div class="global-container">
    <div class="card login-form">
      <div class="card-body">
        <div id="logo_home" style="text-align: center; margin-right: 0px">
          <h1>
            <img src="../../../public/img/logo-pardis.png" width="85%" alt="City tours" data-retina="true"
              @click.prevent="gotoHome" style="cursor: pointer" />
          </h1>
        </div>
        <div class="row">
          <h3 style="
              margin: 30px 20px !important;
              color: #635d5d;
              font-weight: 500;
            ">
            تغییر رمز عبور
          </h3>
        </div>

        <div class="sign-in-wrapper">
          <div class="form-group inputContainer">
            <label> رمز عبور جدید</label>
            <input class="form-control" name="first_name" id="first_name" type="password" v-model="data.newPassword"
              @blur="$v.data.newPassword.$touch()" :class="{ invalid: $v.data.newPassword.$error }" />
            <i class="icon_lock_alt"></i>
            <p class="text-danger" v-if="data.newPassword.length < 6 && $v.data.newPassword.$dirty">
              کلمه عبور حداقل شامل 6 حرف باشد
            </p>
            <!-- <p
              class="text-danger"
              v-if="
                passwordValidation.errors.length && $v.data.newPassword.$dirty
              "
            >
              کلمه عبور باید شامل حروف کوچک، بزرگ و حداقل یک کاراکتر خاص باشد
            </p> -->
          </div>
          <div class="form-group inputContainer">
            <label>تکرار رمز عبور جدید</label>
            <input class="form-control" name="first_name" type="password" v-model="data.confirmPassword"
              @blur="$v.data.confirmPassword.$touch()" :class="{ invalid: $v.data.confirmPassword.$error }" />
            <i class="icon_lock_alt"></i>

            <p class="text-danger" v-if="!$v.data.confirmPassword.sameAsPassword">
              تکرار کلمه عبور صحیح نمی باشد
            </p>
          </div>
          <div class="float-right" style="margin-bottom: 20px">
            <router-link to="/login"> بازگشت به صفحه ورود کاربر </router-link>
          </div>
          <div class="text-center">
            <button v-if="!isLoading" type="submit" @click.prevent="resetPassword" :disabled="$v.$invalid"
              :class="{ disabledBtn: $v.$invalid }" class="btn_login">
              تغییر رمز عبور
            </button>

            <button v-if="isLoading" type="submit" class="btn_login">
              تغییر رمز عبور
              <loadingBar type="ring" class="loading-btn"></loadingBar>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import store from "../../store/index";
import loadingBar from "@/components/loading/pdkLoadingBar";
import { required, minLength, sameAs } from "vuelidate/lib/validators";

export default {
  name: "PdkLogin",
  store,
  components: {
    loadingBar,
  },

  data() {
    return {
      isLoading: false,
      data: {
        newPassword: "",
        confirmPassword: "",
      },
      rules: [
        { message: "One lowercase letter required.", regex: /[a-z]+/ },
        { message: "One uppercase letter required.", regex: /[A-Z]+/ },
        { message: "special characters minimum.", regex: /[!@#$%^&*()_+]/ },
      ],
    };
  },
  validations: {
    data: {
      newPassword: { required, minLength: minLength(6) },
      confirmPassword: { required, sameAsPassword: sameAs("newPassword") },
    },
  },
  computed: {
    passwordValidation() {
      let errors = [];

      for (let condition of this.rules) {
        if (!condition.regex.test(this.data.newPassword)) {
          errors.push(condition.message);
        }
      }
      if (errors.length === 0) {
        return { valid: true, errors };
      } else {
        return { valid: false, errors };
      }
    },
  },
  created() {
    const params = this.$route.query;
    if (params.email === undefined) this.gotoHome();
  },
  methods: {
    async resetPassword() {
      const params = this.$route.query;

      const data = {
        email: params.email,
        password: this.data.newPassword,
        confirmPassword: this.data.confirmPassword,
        code: params.code,
      };

      const res = await this.$store.dispatch("resetPassword", data);

      if (res.status === 200) {
        const resetParams = {
          isUpdatedPassword: true,
          profileId: null,
          email: params.email,
          password: this.data.newPassword,
        };
        await this.$store.dispatch("updateIsUpdatedPassword", resetParams);

        if (res.status == 200) this.$router.push("/login");
        else {
          // alert("خطا در تغییر رمز عبور");
          this.$toast.error("خطا در تغییر رمز عبور", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
        }
      }
    },
    gotoHome() {
      if (this.$route.name != "main home") this.$router.push("/");
    },
  },
};
</script>
<style scoped>
.invalid {
  border: 1px solid red !important;
  box-shadow: 0 0 5px red !important;
}

.loading-btn {
  padding-right: 50px !important;
}

.small-dialog-header {
  font-size: 18px;
  width: calc(100%);
  right: 0px;
  top: 0;
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
  display: inline-block;
  background-color: #fff;
  padding: 15px 20px;
  margin-bottom: 30px;
}

#logo_home h1 a,
header#colored #logo_home h1 a,
header#plain #logo_home h1 a,
header.sticky #logo_home h1 a {
  width: 160px;
  height: 34px;
  display: block;
  background-image: url(../../../public/img/pdk_logo.png);
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 160px 34px;
  text-indent: -9999px;
  text-align: center;
  margin: 20px;
}
</style>

<style >
html,
body {
  height: 100%;
  background-color: #f5f7f9;
}

.global-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7f9;
  padding-top: 10%;
}

.form-control {
  font-size: 13px;
  color: #333;
  height: 40px;
  border-radius: 3px;
  padding-right: 40px;
}

.card-title {
  font-weight: 300;
}

.btn {
  font-size: 14px;
  margin-top: 20px;
}

.login-form {
  width: 500px;
  margin: 20px;
}

.card-body {
  padding: 30px 15px 30px 15px;
  line-height: 1.6 !important;
  border-top: 0px solid;
}

.inputContainer i {
  font-size: 20px;
  color: #11bddbad;
  margin-bottom: 6px;
  margin-right: -8px;
}

.inputContainer {
  width: 100%;
  margin-bottom: 10px;
}
</style>